import { Injector, NgModule, ErrorHandler, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule, Router } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';

import * as Sentry from '@sentry/angular';

import { Amplify } from '@aws-amplify/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ModalModule } from 'ngx-bootstrap/modal';
import { RadarFormlyModule } from '@app/formly/formly.module';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { AppInjector } from './app-injector.service';
import { AppComponent } from './app.component';
import { GraphQLModule } from './graphql.module';
import { LayoutModule } from './layout/layout.module';
import { ApolloModule } from 'apollo-angular';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { UiV2Module } from './ui-v2/ui-v2.module';
import { LeadBoostModule } from './lead-boost/lead-boost.module';

import { provideSvgIconsConfig } from '@ngneat/svg-icon';

import { svgIconsConfig } from '@voyagu/radar-design-system';
import awsconfig from '../aws-config';

Amplify.configure(awsconfig);

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    ApolloModule,
    RouterModule.forRoot([]),
    GraphQLModule,
    LayoutModule,
    BrowserAnimationsModule,
    RadarFormlyModule,
    BsDatepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    AlertModule.forRoot(),
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    NgxPageScrollCoreModule.forRoot({ duration: 150 }),
    TimepickerModule.forRoot(),
    TooltipModule.forRoot(),
    NgxChartsModule,
    UiV2Module,
    LeadBoostModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-US',
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideSvgIconsConfig(svgIconsConfig),
  ],
})
export class AppModule {
  constructor(injector: Injector) {
    AppInjector.injector = injector;
  }
}
